import get from 'lodash/get';

export default function isCheckingFormFieldDisabled(fieldKey, formData) {
  if (get(formData, 'paymentOption', false)) {
    switch (fieldKey) {
      case 'accountNumber':
      case 'routingNumber':
        return true;

      default:
        return false;
    }
  }

  return false;
}
